module.exports = __webpack_public_path__ + "static/img/00.ea24bbe7.png";